<style lang="less">
.zzl-fpb {
  .zzl-fpb-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    min-height: 25px;
    padding: 0 28px 0 8px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 3px;
    transition: background 0.15s, color 0.15s;

    &:hover:not(.disabled) {
      background: rgba(45, 140, 240, 0.06);
    }

    &.disabled {
      cursor: not-allowed;
    }

    &.filled {
      color: var(--primary);
    }

    &.empty {
      color: #aaa;
    }
  }

  .zzl-fpb-trigger-icon {
    flex-shrink: 0;
    font-size: 14px;
    opacity: 0.85;
  }

  .zzl-fpb-trigger-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.zzl-fpb-modal {
  padding: 0;
}

.zzl-fpb-summary {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
}

.zzl-fpb-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.zzl-fpb-summary-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2, #333);
}

.zzl-fpb-summary-count {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(45, 140, 240, 0.1);
  color: var(--primary);
  font-size: 11px;
  font-weight: 500;
}

.zzl-fpb-progress {
  height: 4px;
  border-radius: 2px;
  background: #e8eaec;
  overflow: hidden;
}

.zzl-fpb-progress-bar {
  height: 100%;
  border-radius: 2px;
  background: var(--primary);
  transition: width 0.25s ease;
}

.zzl-fpb-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.zzl-fpb-item {
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: rgba(45, 140, 240, 0.35);
  }

  &.filled {
    border-color: rgba(45, 140, 240, 0.45);
    box-shadow: 0 1px 4px rgba(45, 140, 240, 0.08);
  }
}

.zzl-fpb-item-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f8f9fb;
  border-bottom: 1px solid var(--border);
}

.zzl-fpb-item-label {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--text2, #333);
}

.zzl-fpb-item-status {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;

  &.filled {
    background: rgba(25, 190, 107, 0.12);
    color: #19be6b;
  }

  &.empty {
    background: #f0f0f0;
    color: #aaa;
  }
}

.zzl-fpb-item-desc {
  padding: 6px 12px 0;
  color: var(--subtext2);
  font-size: 11px;
  line-height: 1.5;
}

.zzl-fpb-item-body {
  padding: 10px 12px 12px;

  .fps-wrap {
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }
}

.zzl-fpb-warn {
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px dashed #ff9900;
  border-radius: 6px;
  background: #fff9f0;
  color: #ff9900;
  font-size: 12px;
}

.zzl-fpb-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.zzl-fpb-footer-tip {
  font-size: 11px;
  color: var(--subtext2);
}

.zzl-fpb-footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>

<template>
  <div class="pd-embed-control zzl-fpb" :class="{ 'pd-embed-control-disabled': !editable }">
    <div
      class="zzl-fpb-trigger"
      :class="{ filled: isFilled, empty: !isFilled, disabled: !editable }"
      @click="openModal"
    >
      <Icon type="md-git-compare" class="zzl-fpb-trigger-icon" />
      <span class="zzl-fpb-trigger-text">{{ triggerLabel }}</span>
    </div>

    <Modal
      v-model="modalOpen"
      :width="720"
      title="表单字段绑定"
      footer-hide
      class-name="zzl-fpb-modal-wrap"
      @on-visible-change="onModalVisible"
    >
      <div class="zzl-fpb-modal">
        <div class="zzl-fpb-summary">
          <div class="zzl-fpb-summary-head">
            <div class="zzl-fpb-summary-title">
              <Icon type="md-link" />
              <span>绑定配置</span>
            </div>
            <span class="zzl-fpb-summary-count">
              {{ draftFilledCount }}/2 已填
            </span>
          </div>
          <div class="zzl-fpb-progress">
            <div
              class="zzl-fpb-progress-bar"
              :style="{ width: `${progressPercent}%` }"
            />
          </div>
        </div>

        <div v-if="!currentFormId" class="zzl-fpb-warn">
          未获取到当前表单 ID，请通过 option.formId 传入，或确认路由 query.fID 存在。
        </div>

        <div class="zzl-fpb-list">
          <div
            class="zzl-fpb-item"
            :class="{ filled: hasPosition(draft.thisPosition) }"
          >
            <div class="zzl-fpb-item-head">
              <span class="zzl-fpb-item-label">当前表绑定字段</span>
              <span
                class="zzl-fpb-item-status"
                :class="hasPosition(draft.thisPosition) ? 'filled' : 'empty'"
              >
                {{ hasPosition(draft.thisPosition) ? '已填' : '未填' }}
              </span>
            </div>
            <div class="zzl-fpb-item-desc">
              选择当前表单中用于关联的字段位置
            </div>
            <div class="zzl-fpb-item-body">
              <FormPositionSelect
                :value="thisPositionValue"
                :fixed-form-id="currentFormId"
                :show-form-select="false"
                :show-flags="false"
                :editable="editable && !!currentFormId"
                :platform="platform"
                @input="onThisPositionInput"
              />
            </div>
          </div>

          <div
            class="zzl-fpb-item"
            :class="{ filled: hasThatSide }"
          >
            <div class="zzl-fpb-item-head">
              <span class="zzl-fpb-item-label">绑定表绑定字段</span>
              <span
                class="zzl-fpb-item-status"
                :class="hasThatSide ? 'filled' : 'empty'"
              >
                {{ hasThatSide ? '已填' : '未填' }}
              </span>
            </div>
            <div class="zzl-fpb-item-desc">
              先选择绑定表单，再选择该表单中的字段位置
            </div>
            <div class="zzl-fpb-item-body">
              <FormPositionSelect
                :value="thatPositionValue"
                :show-flags="false"
                :editable="editable"
                :platform="platform"
                @input="onThatPositionInput"
              />
            </div>
          </div>
        </div>

        <div class="zzl-fpb-footer">
          <span class="zzl-fpb-footer-tip">两侧字段位置均为 栏目# / 字段#（从 1 起）</span>
          <div class="zzl-fpb-footer-actions">
            <Button size="small" @click="handleClear">清除</Button>
            <Button size="small" @click="handleCancel">取消</Button>
            <Button type="primary" size="small" @click="handleSave">确定</Button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import FormPositionSelect from '@/components/form/zzl/extra/FormPositionSelect.vue';

function emptyPosition() {
  return {
    targetContent: '',
    targetItem: '',
  };
}

function emptyBinding() {
  return {
    left_join_preset_form_fID: '',
    thisPosition: emptyPosition(),
    thatPosition: emptyPosition(),
  };
}

function normalizePosition(v) {
  if (!v || typeof v !== 'object') return emptyPosition();
  return {
    targetContent: v.targetContent != null && v.targetContent !== '' ? Number(v.targetContent) : '',
    targetItem: v.targetItem != null && v.targetItem !== '' ? Number(v.targetItem) : '',
  };
}

function normalizeBinding(v) {
  const base = emptyBinding();
  if (!v || typeof v !== 'object') return base;
  return {
    left_join_preset_form_fID: v.left_join_preset_form_fID != null
      ? String(v.left_join_preset_form_fID)
      : '',
    thisPosition: normalizePosition(v.thisPosition),
    thatPosition: normalizePosition(v.thatPosition),
  };
}

function hasPosition(pos) {
  if (!pos || typeof pos !== 'object') return false;
  return !!(pos.targetContent || pos.targetItem);
}

function hasBindingValue(v) {
  if (!v || typeof v !== 'object') return false;
  return !!(
    v.left_join_preset_form_fID
    || hasPosition(v.thisPosition)
    || hasPosition(v.thatPosition)
  );
}

function positionLabel(pos) {
  if (!hasPosition(pos)) return '';
  const c = pos.targetContent ? `栏目#${pos.targetContent}` : '';
  const i = pos.targetItem ? `字段#${pos.targetItem}` : '';
  return [c, i].filter(Boolean).join(' / ');
}

export default {
  name: 'ZZLFormPositionBindingSelect',
  components: {
    FormPositionSelect,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    db: {
      type: Object,
      default: () => ({}),
    },
    env: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalOpen: false,
      draft: emptyBinding(),
    };
  },
  computed: {
    platform() {
      return (
        (this.option && this.option.platform)
        || (this.db && this.db.platform)
        || (this.env && this.env.platform)
        || (this.$route && this.$route.query && this.$route.query.platform)
        || 'pmis'
      );
    },
    currentFormId() {
      const fromOpt = this.option && (this.option.formId || this.option.fID || this.option.presetForm_fID);
      const fromEnv = this.env && (this.env.formId || this.env.fID);
      const fromDb = this.db && (this.db.fID || this.db.formId || this.db.id);
      const fromRoute = this.$route && this.$route.query && this.$route.query.fID;
      const id = fromOpt || fromEnv || fromDb || fromRoute || '';
      return id && id !== 'create' ? String(id) : '';
    },
    isFilled() {
      return hasBindingValue(this.value);
    },
    draftFilledCount() {
      let n = 0;
      if (hasPosition(this.draft.thisPosition)) n += 1;
      if (this.hasThatSide) n += 1;
      return n;
    },
    progressPercent() {
      return Math.round((this.draftFilledCount / 2) * 100);
    },
    hasThatSide() {
      return !!(this.draft.left_join_preset_form_fID && hasPosition(this.draft.thatPosition));
    },
    triggerLabel() {
      if (!this.isFilled) return '点击配置字段绑定';
      const thisLab = positionLabel(this.value && this.value.thisPosition);
      const thatLab = positionLabel(this.value && this.value.thatPosition);
      const formId = (this.value && this.value.left_join_preset_form_fID) || '';
      const parts = [];
      if (thisLab) parts.push(`本表 ${thisLab}`);
      if (formId || thatLab) {
        parts.push(`绑定表 ${thatLab || formId}`);
      }
      return parts.length ? parts.join(' ↔ ') : '已配置字段绑定';
    },
    thisPositionValue() {
      return {
        presetForm_fID: this.currentFormId,
        ...normalizePosition(this.draft.thisPosition),
        needItemTitle: false,
        needCategory: false,
        needProjectName: false,
        needInputDate: false,
        needInputor: false,
      };
    },
    thatPositionValue() {
      return {
        presetForm_fID: this.draft.left_join_preset_form_fID || '',
        ...normalizePosition(this.draft.thatPosition),
        needItemTitle: false,
        needCategory: false,
        needProjectName: false,
        needInputDate: false,
        needInputor: false,
      };
    },
  },
  methods: {
    hasPosition,
    openModal() {
      if (!this.editable) return;
      this.syncDraftFromValue();
      this.modalOpen = true;
    },
    onModalVisible(visible) {
      if (visible) this.syncDraftFromValue();
    },
    syncDraftFromValue() {
      this.draft = normalizeBinding(this.value);
    },
    onThisPositionInput(v) {
      const pos = normalizePosition(v);
      this.draft = {
        ...this.draft,
        thisPosition: pos,
      };
    },
    onThatPositionInput(v) {
      const formId = v && v.presetForm_fID != null ? String(v.presetForm_fID) : '';
      const pos = normalizePosition(v);
      const formChanged = formId !== this.draft.left_join_preset_form_fID;
      this.draft = {
        ...this.draft,
        left_join_preset_form_fID: formId,
        thatPosition: formChanged && !hasPosition(pos)
          ? emptyPosition()
          : pos,
      };
    },
    buildOutput(draft) {
      const next = normalizeBinding(draft);
      if (!hasBindingValue(next)) return undefined;
      return cloneDeep(next);
    },
    handleSave() {
      this.$emit('input', this.buildOutput(this.draft));
      this.modalOpen = false;
    },
    handleClear() {
      this.$emit('input', undefined);
      this.modalOpen = false;
    },
    handleCancel() {
      this.modalOpen = false;
    },
  },
};
</script>
